import { useEffect } from "react";
import { useForm } from "../../useForm";

import { Dialog } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

import Input from "../../../controls/Input";
import SelectMenu from "../../../controls/SelectMenu";
import ButtonSpinner from "../../../controls/ButtonSpinner";

const initialFValues = {
    supplier_id: { value: null, label: "" },
    vendor_sku: "",
};

export default function VendorSkuForm(props) {
    const { actionCall, setOpen, inProgress, supplierOptions, isEdit, vendorSku } = props;

    const {
        values,
        setValues,
        errors,
        setErrors,
        handleInputChange,
    } = useForm(initialFValues, false);

    useEffect(() => {
        if (isEdit && vendorSku) {
            setValues({
                vendor_sku: vendorSku.vendor_sku || "",
            });
        }
    }, [isEdit, vendorSku, setValues]);

    const validate = (fieldValues = values) => {
        let temp = { ...errors };

        if (!isEdit) {
            if ("supplier_id" in fieldValues) {
                temp.supplier_id = null;
                if (!fieldValues.supplier_id || !fieldValues.supplier_id.value) {
                    temp.supplier_id = "This field is required.";
                }
            }
        }

        if ("vendor_sku" in fieldValues) {
            temp.vendor_sku = null;
            // vendor_sku is optional, so no validation needed
        }

        setErrors({
            ...temp,
        });

        if (fieldValues === values) {
            return Object.values(temp).every((x) => x === null);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validate()) {
            actionCall(values);
        }
    };

    return (
        <form className="flex h-full flex-col">
            <div className="flex min-h-0 flex-1 flex-col overflow-y-scroll">
                <div className="">
                    <div className="flex items-start justify-between">
                        <Dialog.Title className="text-base font-semibold leading-6 text-gray-900">
                            {isEdit ? "Edit Vendor SKU" : "Add Vendor SKU"}
                        </Dialog.Title>
                        <div className="ml-3 flex h-7 items-center">
                            <button
                                type="button"
                                className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                onClick={() => setOpen({ childComponent: null, open: false })}
                            >
                                <span className="sr-only">Close panel</span>
                                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                            </button>
                        </div>
                    </div>
                </div>
                <div className="relative flex-1 space-y-4">
                    {!isEdit && (
                        <SelectMenu
                            handleInputChange={handleInputChange}
                            name="supplier_id"
                            options={supplierOptions || []}
                            value={values.supplier_id}
                            title="Supplier"
                            error={errors.supplier_id}
                            menuPortalTarget={document.body}
                        />
                    )}
                    <Input
                        label="Vendor SKU"
                        name="vendor_sku"
                        onChange={handleInputChange}
                        value={values.vendor_sku}
                        labelOn={true}
                        type="text"
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
                        error={errors.vendor_sku}
                    />
                </div>
            </div>
            <div className="flex flex-shrink-0 justify-end px-4 py-4">
                <button
                    type="button"
                    className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:ring-gray-400"
                    onClick={() => setOpen({ childComponent: null, open: false })}
                >
                    Cancel
                </button>
                <button
                    type="submit"
                    className="ml-4 inline-flex justify-center rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    onClick={handleSubmit}
                >
                    <ButtonSpinner spin={inProgress} text={isEdit ? "Save" : "Create"} />
                </button>
            </div>
        </form>
    );
}
